import dataModel from "data-model";
import { IPostSaveTrackingPayload } from "../models";

interface JQueryErrorResponse {
  responseJSON?: JQueryResponseJSON
}

interface JQueryResponseJSON {
  message?: string
}

export const fetchTntProvidersAsync = () => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest("Lookup/TrackingProviders")
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const fetchTntVendorsAsync = () => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest("Lookup/TrackingVendors")
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const getAgencyContactDetailsAsync = async () => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest("Agency/GetAgencyContactDetails")
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const sendSaveTrackings = async (
  payload: IPostSaveTrackingPayload[]
) => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest("v2/Tracking/SaveTracks", "POST", payload, true)
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const sendSearchTracking = async (sorTrackingId: string) => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest(
        "v2/Tracking/SearchTracking",
        "POST",
        { sorTrackingId },
        true
      )
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const sendCancelTracking = async (sorTrackingIds: string[]) => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest(
        "v2/Tracking/CancelTracking",
        "POST",
        { sorTrackingIds },
        true
      )
      .done(resolve)
      .fail((err) => reject(err));
  });
};

export const sendTracking = async (
  sorTrackingId: string,
  isBrokered: boolean,
  useELDTracking: boolean
) => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest(
        "v2/Tracking/SendTrack",
        "POST",
        { sorTrackingId, isBrokered, useELDTracking },
        true
      )
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const fetchDriverContactListAsync = async (driverExId: string) => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest("DriverContact/GetByExternalId", "GET", { driverExId }, true)
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const fetchLastLocationAsync = (sorTrackingId: string) => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest(
        "v2/Tracking/GetLastLocation",
        "GET",
        { sorTrackingId },
        true
      )
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const sendByPassTrackingAsync = (payload: {
  movementExId: string;
  byPassTracking: boolean;
}) => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest("v2/Tracking/SaveByPassTracking", "POST", payload, true)
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const fetchByPassTrackingAsync = (movementExId: string) => {
  return new Promise((resolve, reject) => {
    dataModel
      .ajaxRequest(
        "v2/Tracking/GetByPassTracking",
        "GET",
        { movementExId },
        true
      )
      .done(resolve)
        .fail((err) => reject(err));
  });
};

export const fetchTrackingMapsAsync = (orderId: number) => {
  return new Promise((resolve, reject) => {
    dataModel.ajaxRequest("Order/TntTrackingMapLocations", "GET", { orderId }, true)
    .done((resolve))
    .fail((err) => reject((err.responseJSON && err.responseJSON.message) || `An error occurred during request.`))
  })
}